<template>
  <div style="height: 32px;width:100%;">
    <div id="enable-zcy-sky"></div>
    <div id="zcy-sky"></div>
  </div>
  <!-- <div class="top-wrapper">
    <div class="top-content">
      <div class="top-infos">{{timeRange}}！
        <span v-if="!loginStatus"><a :href="`${hasEnvHref && envHref.member}/login?target=${hasEnvHref && envHref.app}`">请登录</a>&nbsp;&nbsp;|&nbsp;&nbsp;<a :href="`${hasEnvHref && envHref.middle}/settle-front/#/registry`">注册</a></span>
        <zcy-top-link v-else :links="loginLink"></zcy-top-link>
      </div>
      <div class="top-links">
        <zcy-top-link v-for="(item, index) in linkList" :key="index" :links="item"></zcy-top-link>
      </div>
    </div>
  </div>-->
</template>

<script>
export default {
  created () {
    window.skyConfig = {
      hideDistrict: true,
      index: 'app',
      customizeMenus: (menus, user, hrefs) => {
        // return menus.splice(3);
        return menus.filter(function (menu) {
          return menu.id !== 'sky-app' && menu.id !== 'sky-fpg' && menu.id !== 'sky-qyg';
        });
      },
      onReady: data => {
        if (data.user) {
          window.currentUserIdentity = data.user;
          this.$emit('login-status-change', true);
        }
        if (data.hrefs) {
          window.envHref = data.hrefs;
          this.$emit('env-success');
        }
      }
    };
  }
};
// import Links from './links';
// // import request, { setEnvHref } from '@/utils/request';
// import { getAppsBasicInfo, getEnvHref, getLoginStatus } from '@/services';
// import cookie from 'cookie';

// // 获取环境变量和用户标识信息
// let envHref, currentUserIdentity;
// if (localStorage.getItem('envHref')) {
//   try {
//     envHref = JSON.parse(localStorage.getItem('envHref'));
//     window.envHref || (window.envHref = envHref);
//   } catch (e) {
//     console.log(e);
//   }
// } else {
//   envHref = window.envHref;
//   try {
//     envHref && (localStorage.setItem('envHref', JSON.stringify(envHref)));
//   } catch (e) {
//     console.log(e);
//   }
// }
// if (sessionStorage.getItem('currentUserIdentity')) {
//   try {
//     currentUserIdentity = JSON.parse(sessionStorage.getItem('currentUserIdentity'));
//     window.currentUserIdentity || (window.currentUserIdentity = currentUserIdentity);
//   } catch (e) {
//     console.log(e);
//   }
// } else {
//   currentUserIdentity = window.currentUserIdentity;
//   try {
//     currentUserIdentity && (sessionStorage.setItem('currentUserIdentity', JSON.stringify(currentUserIdentity)));
//   } catch (e) {
//     console.log(e);
//   }
// }
// let myCookie = cookie.parse(document.cookie);
// // let vm;
// export default {
//   components: {
//     'zcy-top-link': Links
//   },
//   data () {
//     return {
//       envHref: envHref,
//       loginStatus: false,
//       hasEnvHref: envHref && !!envHref.member
//     };
//   },
//   computed: {
//     timeRange: function () {
//       let now = new Date();
//       let hour = now.getHours();
//       if (hour >= 6 && hour < 12) {
//         return '早上好';
//       } else if (hour === 12) {
//         return '中午好';
//       } else if (hour > 12 && hour < 19) {
//         return '下午好';
//       } else {
//         return '晚上好';
//       }
//     },
//     loginLink: function () {
//       if (this.loginStatus) {
//         return [
//           {
//             text: currentUserIdentity.displayName
//           },
//           {
//             text: '账号信息',
//             href: `${this.hasEnvHref && this.envHref.middle}/web-user/#/account/detail`
//           },
//           {
//             text: '退出',
//             href: `${this.hasEnvHref && this.envHref.logout}`,
//             self: true
//           }
//         ];
//       }
//     },
//     linkList: function () {
//       return [
//         [
//           {
//             text: '我的工作台',
//             href: `${this.hasEnvHref && this.envHref.middle}/guide`
//           }
//         ],
//         [
//           {
//             text: '商家支持',
//             href: ''
//           },
//           {
//             text: '商家入驻',
//             href: `${this.hasEnvHref && this.envHref.middle}/settle-front/#/registry`
//           },
//           {
//             text: '商家规则',
//             href: 'http://rule.zcygov.cn/web/site_1/2017/01/11/68.html'
//           },
//           {
//             text: '商家帮助',
//             href: 'http://help.zcygov.cn/'
//           }
//         ],
//         [
//           {
//             text: '服务大厅',
//             href: ''
//           },
//           {
//             text: '在线客服',
//             href: 'https://cschat.cloud.alipay.com/pcportal.htm?tntInstId=KMQNW3CN&scene=SCE00000041'
//           },
//           {
//             text: '操作指南',
//             href: 'https://help.zcygov.cn/web/site_2/file/index.html'
//           },
//           // {
//           //   text: '帮助中心',
//           //   href: 'http://help.zcygov.cn/'
//           // },
//           {
//             text: '规则中心',
//             href: 'https://rule.zcygov.cn/'
//           },
//           {
//             text: '联系我们',
//             href: 'https://help.zcygov.cn/web/site_2/contactIndex.html'
//           }
//         ],
//         [
//           {
//             text: '培训中心',
//             href: ''
//           },
//           {
//             text: '培训课程',
//             href: 'https://edu.zcygov.cn/'
//           },
//           {
//             text: '培训授权合作伙伴',
//             href: 'https://edu.zcygov.cn/web/site_7/2017/04-28/341.html'
//           },
//           {
//             text: '在线直播入口',
//             href: 'http://zcy.gensee.com/webcast/site/entry/join-2189f3fddc92411a84a0a057ed12002b'
//           }
//         ],
//         [
//           {
//             text: '帮助中心',
//             href: 'http://help.zcygov.cn/'
//           }
//         ]
//       ];
//     }
//   },
//   watch: {
//     hasEnvHref: function (newVal, oldVal) {
//       if (!oldVal && newVal) {
//         this.envHref = window.envHref;
//       }
//     }
//   },
//   created () {
//     console.log('envhref', this.envHref);
//     // 如果都没有envHref则请求后台获取
//     getEnvHref().then((res) => {
//       if (res.success) {
//         window.envHref = res.result;
//         this.hasEnvHref = window.envHref;
//         try {
//           localStorage.setItem('envHref', JSON.stringify(window.envHref));
//         } catch (e) {
//           console.log(e);
//         }
//         this.handleLoginStatus();
//         this.$emit('env-success');
//       }
//     });
//     this.handleLoginStatus();
//   },
//   methods: {
//     handleLoginStatus () {
//       // cookies显示登录，但是没有用户标识，需要同步登录标识
//       if (myCookie.uid && !currentUserIdentity) {
//         getLoginStatus().then((res) => {
//           if (res.success && res.result.loginStatus === 1) {
//             getAppsBasicInfo().then((res) => {
//               if (res.success) {
//                 const userList = res.result.getUserIdentity;
//                 Array.isArray(userList) && userList.some(userItem => {
//                   if (userItem.currentFlag) {
//                     currentUserIdentity = userItem;
//                     window.currentUserIdentity = currentUserIdentity;
//                     try {
//                       sessionStorage.setItem('currentUserIdentity', JSON.stringify(currentUserIdentity));
//                       this.loginStatus = true;
//                       this.$emit('login-status-change', true);
//                     } catch (e) {
//                       console.log(e);
//                     }
//                     return true;
//                   }
//                 });
//               }
//             }).catch(error => {
//               console.log(error);
//             });
//           }
//         });
//       } else if (!myCookie.uid && currentUserIdentity) {
//         // cookies显示未登录，但是有登录标识，需要进行退出操作
//         currentUserIdentity = null;
//         window.currentUserIdentity = null;
//         delete window.currentUserIdentity;
//         sessionStorage.removeItem('currentUserIdentity');
//         this.loginStatus = false;
//         this.$emit('login-status-change', false);
//       } else if (myCookie.uid && currentUserIdentity) {
//         // 如果登录状态则向父组件传递登录状态事件
//         window.currentUserIdentity = currentUserIdentity;
//         this.loginStatus = true;
//         this.$emit('login-status-change', true);
//       } else {
//         // 其余状态均为未登录状态
//         this.loginStatus = false;
//         this.$emit('login-status-change', false);
//       }
//     }
//   }
// };
</script>

<style lang="less" scoped>
// @import "../../assets/css/common.less";
// @top-height: 32px;
// @top-line-height: @top-height;
// .top-wrapper {
//   width: 100%;
//   min-width: @width-full;
//   background: @top-bg-color;
//   height: @top-height;
//   line-height: @top-line-height;
//   font-size: @font-size-s;
//   color: @font-color-link;
//   display: flex;
//   justify-content: center;
//   z-index: 100;
//   .top-content {
//     width: @width-full;
//     display: flex;
//     justify-content: space-between;
//   }
//   .top-infos {
//     display: flex;
//   }
//   .top-links {
//     display: flex;
//   }
// }
//
</style>



// WEBPACK FOOTER //
// src/components/site-top/index.vue